import axios from 'axios';
import { API_BASE_URL } from '../utils/apiConfig';

class LeagueChallengesService {
  getAuthHeaders() {
    const token = localStorage.getItem('moneysmart-token');
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    };
  }

  // Get all challenges for a league (for teachers/admins)
  async getChallenges(leagueId) {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/leagues/${leagueId}/challenges`,
        this.getAuthHeaders()
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  // Get all challenges for a league (for students - read-only)
  async getChallengesForStudent(leagueId) {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/leagues/${leagueId}/challenges/student`,
        this.getAuthHeaders()
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  // Get a single challenge (for teachers/admins)
  async getChallenge(leagueId, challengeId) {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/leagues/${leagueId}/challenges/${challengeId}`,
        this.getAuthHeaders()
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  // Get a single challenge (for students - read-only)
  async getChallengeForStudent(leagueId, challengeId) {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/leagues/${leagueId}/challenges/${challengeId}/student`,
        this.getAuthHeaders()
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  // Create a challenge
  async createChallenge(leagueId, challengeData) {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/leagues/${leagueId}/challenges`,
        challengeData,
        this.getAuthHeaders()
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  // Update a challenge
  async updateChallenge(leagueId, challengeId, challengeData) {
    try {
      const response = await axios.put(
        `${API_BASE_URL}/leagues/${leagueId}/challenges/${challengeId}`,
        challengeData,
        this.getAuthHeaders()
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  // Delete a challenge
  async deleteChallenge(leagueId, challengeId) {
    try {
      const response = await axios.delete(
        `${API_BASE_URL}/leagues/${leagueId}/challenges/${challengeId}`,
        this.getAuthHeaders()
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
}

export default new LeagueChallengesService();

